import { HttpMethods } from "../data/HttpMethods";
import { HttpOptions } from "../data/HttpOptions";
import { HttpResponse } from "../types/HttpResponse";


export const fetchData = async ( options: HttpOptions, query: string  ): Promise<HttpResponse> => {

    try {

        const response: Response = await fetch( query, options );

        if ( response.status === 200 ) {

            return {

                response,
                statusCode: response.status

            };


        } else {

            return {
        
                response: null,
                statusCode: response.status
        
            };

        }

    } catch {

        return {
        
            response: null,
            statusCode: null
    
        };

    }

};


export const getHttpOptions = ( authToken: string, functionKey: string, method: HttpMethods, body: BodyInit | undefined = undefined ): HttpOptions => {

    const headers = new Headers( );
    const bearerToken = `Bearer ${authToken}`;
    headers.append( 'Authorization', bearerToken );
    headers.append( 'x-functions-key', functionKey );
    headers.append( 'content-type', 'application/json' );

    const options: HttpOptions = {
        
        method,
        headers,
        body

    };

    return options;

};


export const getHttpOptionsTokenOnly = ( authToken: string, method: HttpMethods, body: BodyInit | undefined = undefined ): HttpOptions => {

    const headers = new Headers( );
    const bearerToken = `Bearer ${authToken}`;
    headers.append( 'Authorization', bearerToken );
    headers.append( 'content-type', 'application/json' );

    const options: HttpOptions = {
        
        method,
        headers,
        body

    };

    return options;

};